import React from 'react';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import { useComposeDescription } from 'hooks/use-compose-description';
import { theme } from 'styles/configure-theme';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { EntryDescriptionRow, Item, ItemHeader, ItemName, ItemPrice } from './cart-entry.styled';

interface ICartEntry {
  entry: IBackendCartEntries;
  currencyFormatter: Function;
  index?: number;
}

const CartEntry = ({ entry, currencyFormatter }: ICartEntry) => {
  const quantity = entry.quantity || 1;
  const amount = priceForCartEntry(entry);
  const cartEntryDescription = useComposeDescription(entry, { includeModifiers: true });

  return (
    <Item accessible focusable>
      <ItemHeader>
        <ItemName>
          {quantity > 1 && `${quantity}x `}
          {entry.name}
        </ItemName>
        <ItemPrice>
          {entry.price !== null && (
            <Currency
              amount={amount}
              textProps={{
                ...(amount === 0 && { color: theme.token('icon-default') }),
                variant: 'headerFour',
                margin: 0,
                textAlign: 'right',
              }}
            />
          )}
        </ItemPrice>
      </ItemHeader>

      {cartEntryDescription?.length > 0 &&
        cartEntryDescription.map((descriptionItem, index) => (
          <EntryDescriptionRow key={`descriptionItem-${index}`}>
            {descriptionItem}
          </EntryDescriptionRow>
        ))}
    </Item>
  );
};

export default CartEntry;
